import { SKINCARE_CART_URL } from 'constants/urlCart';

import flatUsDollarBadge from 'assets/images/badge_145dollar_us.svg';
import flatCadDollarBadge from 'assets/images/badge_200dollar_cad.svg';
import skincareGroup from 'assets/images/promotionalModals/skincare_products_group.jpg';

const contentMap = {
  US: {
    title: <>Try custom skincare for&nbsp;free</>,
    description: (
      <>
        Get a free full-size Cleanser, Serum, and Moisturizer{' '}
        <strong>($145 value + free&nbsp;shipping!)</strong>.
      </>
    ),
    arch: {
      src: skincareGroup,
      alt: 'skincare trio of products grouped together',
    },
    badge: {
      src: flatUsDollarBadge,
      alt: 'Offer available when you subscribe to haircare and skincare.',
    },
    cta: {
      skincareCompleted: {
        linkTo: SKINCARE_CART_URL,
        dataClick: 'order-your-prose',
        ctaLabel: 'Get your free routine',
      },
      skincareNotCompleted: {
        linkTo: '/consultation/skincare',
        dataClick: 'get-your-formula',
        ctaLabel: 'Get your free routine',
      },
    },
    declineCta: 'No thanks, I’ll pass on this offer',
    conditions:
      'Limited-time offer valid for select customers only. Eligible customers will receive their first subscription skincare order free when they subscribe to Cleanser, Serum, and Moisturizer.',
  },
  CA: {
    description: (
      <>
        Get a free full-size Cleanser, Serum, and Moisturizer{' '}
        <strong>($200 CAD value + free&nbsp;shipping!)</strong>.
      </>
    ),
    badge: {
      src: flatCadDollarBadge,
    },
  },
};

export default contentMap;
